<template>
    <nav
        class="z-[31] flex h-full justify-between"
        :class="expandNav ? 'fixed h-screen w-full bg-gray-900' : ''"
    >
        <div class="flex h-[86px] flex-col p-[25px]">
            <InertiaLink href="/players/me/rounds">
                <Icon name="swingu-white-logo" width="103" height="36" />
            </InertiaLink>
        </div>
        <div
            class="h-[86px] cursor-pointer py-[35px] px-[25px]"
            @click="expandNav = !expandNav"
        >
            <Icon
                v-if="!expandNav"
                name="hamburger-menu"
                class="h-[16px] h-[14px] w-[16px] text-white"
            />
            <Icon
                v-else
                name="close"
                class="h-[16px] h-[15px] w-[15px] text-white"
            />
        </div>
        <div
            :class="
                expandNav
                    ? 'bg-visible fixed bottom-0 left-0 top-[86px] right-0 z-[31] block bg-white text-lg font-semibold text-gray-800'
                    : 'hidden'
            "
        >
            <ul
                id="mobileNavList"
                class="fixed left-0 top-[86px] flex w-full flex-col items-start"
            >
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/players/me/rounds"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Rounds
                        </div>
                    </a>
                </li>
                <li class="w-full border-b border-gray-200">
                    <a class="relative block h-full w-full" href="/players/me">
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Advanced Stats
                        </div>
                    </a>
                </li>
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/players/me/stats/basic"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Basic Stats
                        </div>
                    </a>
                </li>
                <!-- Update to this Clubs link when ready to port in v2 clubs views. -->
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/players/me/clubs"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Clubs
                        </div>
                    </a>
                </li>
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/account/info"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Account Info
                        </div>
                    </a>
                </li>
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/account/settings"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Settings
                        </div>
                    </a>
                </li>
                <li class="w-full border-b border-gray-200">
                    <a
                        class="relative block h-full w-full"
                        href="/account/subscription"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Subscription
                        </div>
                    </a>
                </li>
                <!-- <li class="border-b border-gray-200 w-full">
                    <a
                        class="text-primary-500 h-full block w-full relative"
                        href="/round"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Post Score
                        </div>
                    </a>
                </li> -->
                <li class="w-full border-b border-gray-200">
                    <a
                        :href="$page.props.logoutRoute"
                        class="relative block h-full w-full text-danger-500"
                    >
                        <div
                            class="margin-0 absolute top-1/2 -translate-y-1/2 pl-[25px]"
                        >
                            Log Out
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script setup></script>

<script>
export default {
    data() {
        return {
            expandNav: false,
        };
    },
};
</script>

<style scoped>
nav {
    @apply text-base font-medium leading-none text-white;
}
#mobileNavList {
    height: calc(100vh - 86px);
}

#mobileNavList > li {
    /* height: calc((100vh - 86px) / 9); Uncomment when post score is ready*/
    height: calc((100vh - 86px) / 8);
}
</style>
